<form class="f-col blank-form cm-managetraveler-page" [formGroup]="delegationForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.delegation']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managetraveler.optional']}}</span></h2>

        <a role="button" tabindex="0" role="button" class="link" (click)="editDelegation()"
            *ngIf="Loader.isEditableClicked">
            <mat-icon fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon> {{content?.['b2b.managetraveler.edit']}}
        </a>
    </div>

    <div class="section-content">
        <div class="inner-contentsection">
            <div class="f-row">
                <div class="f-col">
                    <mat-slide-toggle formControlName="onLeave">
                        {{content?.['b2b.managetraveler.onleave']}}
                </mat-slide-toggle>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col position-relative open-calendar-bottom">
                    <mat-form-field appearance="fill" (click)="Loader.isEditableClicked ? null : showComponent('leaveStart'); $event.stopPropagation()">
                        <mat-label>{{content?.['b2b.managetraveler.leavestart']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                        <input matInput formControlName="leaveStart" readonly
                            [value]="selectedLeaveStart ? (selectedLeaveStart | date: 'dd/MM/y') : ''" autocomplete="off" />
                    </mat-form-field>
                    <app-expiry-data-calendar #leaveStartCalendar *ngIf="isCalenderVisible['leaveStart'] && !Loader.isEditableClicked" [AddOnMonths]="0"
                        [minimumDate]="commonObj.minDate" [filledDate]="delegationForm.value.leaveStart" [type]="'leaveStart'"
                        [passengerTravelerCode]="'ADT'" (dateSelected)="onDateSelected($event, 'leaveStart')">
                    </app-expiry-data-calendar>
                </div>
                <div class="f-col position-relative c-position-right open-calendar-bottom">
                    <mat-form-field appearance="fill" (click)="Loader.isEditableClicked ? null : showComponent('leaveEnd'); $event.stopPropagation()">
                        <mat-label>{{content?.['b2b.managetraveler.leaveend']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                        <input matInput formControlName="leaveEnd" readonly
                            [value]="selectedLeaveEnd ? (selectedLeaveEnd | date: 'dd/MM/y') : ''" autocomplete="off" />
                    </mat-form-field>
                    <app-expiry-data-calendar #leaveEndCalendar *ngIf="isCalenderVisible['leaveEnd'] && !Loader.isEditableClicked" [AddOnMonths]="0"
                        [minimumDate]="delegationForm.value.leaveStart || commonObj.minDate"
                        [filledDate]="delegationForm.value.leaveEnd" [type]="'leaveEnd'" [passengerTravelerCode]="'ADT'"
                        (dateSelected)="onDateSelected($event, 'leaveEnd')">
                    </app-expiry-data-calendar>
                </div>
            </div>
            
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field appearance="fill">
                        <mat-label>{{content?.['b2b.managetraveler.delegated']}}</mat-label>
                        <input matInput type="text" [formControl]="delegatedSearchControl"
                            [matAutocomplete]="delegatedAuto" autocomplete="off"
                            (input)="onDelegatedSearchInput($event)" (focus)="onFocusDelegatedTo()" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="delegatedSearchControl.value && !Loader.isEditableClicked"
                            (click)="clearDelegatedTo($event)" aria-label="Clear delegated user">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #delegatedAuto="matAutocomplete" (optionSelected)="onDelegatedSelected($event)">
                            <mat-option *ngIf="delegatedList.length === 0" [disabled]="true">
                                {{delegatedNoItemsText}}
                            </mat-option>
                            <mat-option *ngFor="let user of delegatedList" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.managetraveler.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action" *ngIf="!Loader.isEditableClicked">
            <button mat-button class="button--secondary-small" (click)="cancelDelegation()">{{content?.['b2b.managetraveler.cancel']}}</button>
            <button mat-button class="button--primary-small"
                [disabled]="saveButtonDisabled"
                (click)="saveDelegation()">{{content?.['b2b.managetraveler.save']}}</button>
        </div>
    </div>
</form>
